import { render, staticRenderFns } from "./Intitution.vue?vue&type=template&id=7341dda4"
import script from "./Intitution.vue?vue&type=script&lang=js"
export * from "./Intitution.vue?vue&type=script&lang=js"
import style0 from "./Intitution.vue?vue&type=style&index=0&id=7341dda4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports